import React from "react";
import { Target, Telescope } from "lucide-react";
import { PageBanner } from "../components/Shared";
import "./InnerPages.css";

const MissionVisionPage = () => {
  return (
    <>
      <PageBanner title="Mission & Vision" breadcrumb="About / Mission & Vision" />
      <section className="section">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card mv-card--accent">
              <div className="mv-card__icon"><Target size={30} /></div>
              <h3>Our Mission</h3>
              <p>
                To nurture the continuous growth of young minds through the
                provision of quality education intertwined with human values. To
                identify and enhance inherent skills, while empowering students'
                physical, emotional, and intellectual faculties through a
                comprehensive educational approach that integrates global trends
                with traditional Indian values.
              </p>
            </div>
            <div className="mv-card mv-card--primary">
              <div className="mv-card__icon"><Telescope size={30} /></div>
              <h3>Our Vision</h3>
              <p>
                To provide high-quality education that equips students with the
                knowledge and skills necessary for academic excellence and
                success in life. We believe in fostering the ethos of
                "Vasudhaiva Kutumbakam" within the Indian society, thus
                contributing to India's emergence as a future leader on the
                global stage.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MissionVisionPage;
